import { Tooltip } from "@mui/material";
import { SpeechBubbleIcon } from "~/icons";

export const PendingExceptionsTooltip = () => {
  return (
    <Tooltip title="Exceptions pending review" placement="top" arrow>
      <SpeechBubbleIcon color="warning" sx={{ fontSize: 16 }} />
    </Tooltip>
  );
};
